import { memo } from "react";
import VerifyEmailStep from "@/components/intake/VerifyEmailStep";
import type { IntakeData } from "@/lib/types";
import { useIntakeMobileChromeRegistration } from "../IntakeMobileChromeContext";

interface VerificationCardProps {
  data: IntakeData;
  onUpdate: (data: Partial<IntakeData>) => void;
  onSuccess: () => void;
  onBack: () => void;
  formUid?: string;
  referenceUid?: string;
}

// Reuse the existing verification steps — dentistry flow uses OTP, others use magic-link
// For v2 (non-dentistry), we use VerifyEmailStep
export const VerificationCard = memo(function VerificationCard({
  data,
  onUpdate,
  onSuccess,
  onBack,
  formUid,
  referenceUid,
}: VerificationCardProps) {
  useIntakeMobileChromeRegistration(
    () => ({ onCancel: onBack, showContinue: false }),
    [onBack],
  );

  return (
    <div className="w-full max-w-lg">
      <VerifyEmailStep
        data={data}
        onUpdate={onUpdate}
        onVerificationSuccess={onSuccess}
        onBack={onBack}
        formUid={formUid}
        referenceUid={referenceUid}
        embeddedInFlow
      />
    </div>
  );
});
